import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, Eye, EyeOff } from 'lucide-react';

// Maße der Anmeldeseiten wie im PersoNYzer (L1 C4), gemeinsam für Login, Passwort und Zugangscode.
export const FELD = 'h-11 w-full rounded-[6px] border border-[#d6dde3] bg-transparent pl-10 pr-3 text-sm text-[#0e1628] shadow-[0_1px_2px_rgba(0,0,0,.05)] placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1d4ed8]/40 focus-visible:border-[#1d4ed8]';
const HAUPT_STIL = { background: 'linear-gradient(135deg,#3a6ff0 0%,#1e4fd0 45%,#1e3a9e 100%)', boxShadow: '0 6px 16px rgba(30,64,175,.24)' };

export const Titel = ({ children, testid }) => (
  <h1 className="text-[30px] font-bold leading-[1.25] tracking-[-0.022em] text-[#0e1628]" style={{ fontFamily: "'Inter', sans-serif" }} data-testid={testid}>{children}</h1>
);

export const Unterzeile = ({ children, testid }) => (
  <p className="mt-1 text-base text-[#4b5768]" data-testid={testid}>{children}</p>
);

export const Beschriftung = ({ htmlFor, children }) => (
  <label htmlFor={htmlFor} className="mb-1.5 block text-sm font-medium text-[#0e1628]">{children}</label>
);

// Eingabefeld mit Symbol links (16 px, #94a3b8) und optionalem Element rechts (z. B. Auge).
export const Feld = React.forwardRef(({ symbol: Symbol, rechts, className = '', ...rest }, ref) => (
  <div className="relative">
    {Symbol && <Symbol className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#94a3b8]" aria-hidden="true" />}
    <input ref={ref} className={`${FELD} ${rechts ? 'pr-10' : ''} ${className}`} {...rest} />
    {rechts}
  </div>
));
Feld.displayName = 'Feld';

export const Auge = ({ sichtbar, onClick, testid }) => (
  <button type="button" onClick={onClick} aria-label={sichtbar ? 'Passwort verbergen' : 'Passwort anzeigen'}
    className="absolute right-3 top-1/2 -translate-y-1/2 text-[#94a3b8] transition-colors hover:text-slate-600" data-testid={testid}>
    {sichtbar ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
  </button>
);

export const Hauptknopf = ({ children, className = '', ...rest }) => (
  <button className={`inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg text-sm font-semibold text-white transition-[filter,opacity] hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-60 ${className}`} style={HAUPT_STIL} {...rest}>
    {children}
  </button>
);

export const Nebenknopf = ({ to, children, testid }) => (
  <Link to={to} className="inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg border border-[#cbd5e1] bg-white text-sm font-medium text-[#0e1628] transition-colors hover:bg-slate-50" data-testid={testid}>
    {children}
  </Link>
);

export const Oder = () => (
  <div className="flex items-center gap-3" aria-hidden="true">
    <span className="h-px flex-1 bg-[#e2e8f0]" />
    <span className="text-[13px] text-[#94a3b8]">oder</span>
    <span className="h-px flex-1 bg-[#e2e8f0]" />
  </div>
);

export const Fehlerkasten = ({ children, testid }) => (
  <div role="alert" className="flex items-start gap-2 rounded-lg border border-[#fecaca] bg-[#fef2f2] px-3 py-2 text-sm text-[#b91c1c]">
    <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
    <span data-testid={testid}>{children}</span>
  </div>
);

export const TextLink = ({ to, children, testid, className = '' }) => (
  <Link to={to} className={`text-sm text-[#1d4ed8] hover:underline ${className}`} data-testid={testid}>{children}</Link>
);
